export default "__VITE_PUBLIC_ASSET__d72e3091__"